import { format, differenceInDays, subMonths, subDays, max, min } from "date-fns";

// Constants for various offsets
const YEAR_OFFSET = -1;
const MONTH_OFFSET = -1;
const WEEK_OFFSET = -1;
const ALIGN_DAY_OFFSET = -364;
const ALIGN_MONTH_DAY_OFFSET = -28;

const formatDate = (date) => format(new Date(date), 'yyyy-MM-dd');

// Function to adjust a date range based on unit and offset
const adjustRange = (startDate, endDate, unit, offset, align = false) => {
  const adjustedStart = new Date(startDate);
  const adjustedEnd = new Date(endDate);

  if (align) {
    adjustedStart.setDate(adjustedStart.getDate() + offset);
    adjustedEnd.setDate(adjustedEnd.getDate() + offset);
  } else {
    switch (unit) {
      case 'year':
        adjustedStart.setFullYear(adjustedStart.getFullYear() + offset);
        adjustedEnd.setFullYear(adjustedEnd.getFullYear() + offset);
        break;
      case 'month':
        adjustedStart.setMonth(adjustedStart.getMonth() + offset);
        adjustedEnd.setMonth(adjustedEnd.getMonth() + offset);
        break;
      case 'week':
        adjustedStart.setDate(adjustedStart.getDate() + offset * 7);
        adjustedEnd.setDate(adjustedEnd.getDate() + offset * 7);
        break;
    }
  }

  return {
    startDate: formatDate(adjustedStart),
    endDate: formatDate(adjustedEnd),
  };
};

const applySymmetricUnalignedLogic = (stayDateRange, bookingDateRange) => {
  const minBookingDate = min(bookingDateRange);
  const maxBookingDate = max(bookingDateRange);
  const maxStayDate = max(stayDateRange);
  
  const bookingDuration = differenceInDays(maxBookingDate, minBookingDate);
  const gap = differenceInDays(maxStayDate, maxBookingDate);
  
  const maxComparison = subMonths(maxStayDate, 1);
  const max_ = subDays(maxComparison, gap);
  const min_ = subDays(max_, bookingDuration);

  console.log("apply symmetric month booking date range", min_,max_)
  return {
    startDate: formatDate(min_),
    endDate: formatDate(max_),
  };
};



export const calculateComparisonDates = (
  stayDate,
  summaryBookingDate,
  alignmentToggle,
  symmetricComparisonToggle,
  dateComparison
) => {

  let allBookingDates = {"startDate":"2015-01-01","endDate": formatDate(new Date())}
  let adjustedStayDate = {
    startDate: formatDate(stayDate.startDate),
    endDate: formatDate(stayDate.endDate),
  };
  let adjustedBookingDate = {
    startDate: formatDate(summaryBookingDate.startDate),
    endDate: formatDate(summaryBookingDate.endDate),
  };

  switch (dateComparison) {
    case "Previous Year":
      adjustedStayDate = alignmentToggle
        ? adjustRange(stayDate.startDate, stayDate.endDate, 'year', ALIGN_DAY_OFFSET, true)
        : adjustRange(stayDate.startDate, stayDate.endDate, 'year', YEAR_OFFSET, false);

      if (symmetricComparisonToggle) {
        adjustedBookingDate = alignmentToggle
          ? adjustRange(summaryBookingDate.startDate, summaryBookingDate.endDate, 'year', ALIGN_DAY_OFFSET, true)
          : adjustRange(summaryBookingDate.startDate, summaryBookingDate.endDate, 'year', YEAR_OFFSET, false);
      }else{
        adjustedBookingDate = allBookingDates
      }
      break;

    case "Previous Month":
      if (symmetricComparisonToggle && !alignmentToggle) {
        adjustedBookingDate = applySymmetricUnalignedLogic(
          [new Date(stayDate.startDate), new Date(stayDate.endDate)],
          [new Date(summaryBookingDate.startDate), new Date(summaryBookingDate.endDate)]
        );
        adjustedStayDate = adjustRange(stayDate.startDate, stayDate.endDate, 'month', MONTH_OFFSET, alignmentToggle);
      } else {
        const offset = alignmentToggle ? ALIGN_MONTH_DAY_OFFSET : MONTH_OFFSET;
        adjustedStayDate = adjustRange(stayDate.startDate, stayDate.endDate, 'month', offset, alignmentToggle);

        if (symmetricComparisonToggle) {
          adjustedBookingDate = adjustRange(summaryBookingDate.startDate, summaryBookingDate.endDate, 'month', offset, alignmentToggle);
        }else{
          adjustedBookingDate = allBookingDates
        }
      }
      break;

    case "Previous Week":
      adjustedStayDate = adjustRange(stayDate.startDate, stayDate.endDate, 'week', WEEK_OFFSET);
      if (symmetricComparisonToggle) {
        adjustedBookingDate = adjustRange(summaryBookingDate.startDate, summaryBookingDate.endDate, 'week', WEEK_OFFSET);
      }else{
        adjustedBookingDate = allBookingDates
      }
      break;

    case "OTB":  //Will return Revenue for all booking dates
      return {
        adjustedStayDate,
        adjustedBookingDate: allBookingDates
      };

    default:
      console.log("error in date comparison value");
  }

  return { adjustedStayDate, adjustedBookingDate }
};
